function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }


import classNames from 'classnames';
import React, { useContext } from 'react';
import { HeadingContext } from './Section';
import Text from './Text';
import { useTheme } from './ThemeContext';
const styles = require('./Heading-styles.module.scss');

/**
 * Composes `<Text>` and accepts all the same props.
 */
function Heading({
  as: tag,
  level: levelOverride,
  ruled = false,
  className,
  ...props
}) {
  const theme = useTheme(props.theme);
  const level = useContext(HeadingContext);
  const as = tag || `h${levelOverride || level}`;
  return React.createElement(Text, _extends({
    as: as,
    variant: "lg",
    color: "headline",
    className: classNames(className, styles.heading, ruled && styles[`${theme}Ruled`])
  }, props));
}

export default Heading;